export { default } from './FinesTotalCapsule';



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/FinesTotalCapsule/index.js